/**
 * The option id a customer filter uses for "no customer assigned".
 *
 * Customer ids are positive database ids, so -1 can never collide with a real
 * one. Filters put it alongside real ids so "only unassigned" and "this customer
 * or unassigned" are expressible in the same list.
 */
export const NO_CUSTOMER_ID = -1

export const NO_CUSTOMER_LABEL = 'No Customer Assigned'
